<div class="blue-overlay pt-5 pb-5 text-center text-white">
    <div class="container">
        <div class="h3 text-white">Bridging Worlds</div>
        <div class="h1 fw-bolder mb-4 text-white">Cutting Edge Technology Uniting Global Travel Suppliers and Sellers
        </div>
        <p>The digital revolution has transformed industries across the globe, and the travel sector stands at the
            forefront of this evolution. With the rise of mobile, tablet, and web-based bookings dominating
            transactions, the way business is conducted has been forever changed.</p>
        <p>In this dynamic ecosystem, Online Travel Agencies (OTAs) require trusted {{clientAbbr}} travel partners who
            deliver meticulously curated offerings to cater to the refined preferences of today’s savvy travelers. Our
            innovative platforms connect suppliers and sellers worldwide, setting new standards for reliability,
            efficiency, and customer satisfaction in a fast-paced, technology-driven industry.</p>
        <a routerLink="/signup" class="btn btn-lg blue-btn text-white mt-2">Register Now</a>
    </div>
</div>